<template>
  <div class="rate-card"  >
    <el-row style="padding:8px 0">
      <el-col :span="24" class="title">{{ data.name }}</el-col>
    </el-row>
    <el-row style="padding:12px 0" >
      <el-col :span="5" class="rate" :title="data.value">
        {{ data.value }}</el-col
      >
      <el-col :span="5"> <i class="el-icon-top arrow" :class="{'down': data.compare != 1}"></i> </el-col>
      <el-col :span="14">
        <div class="rate-number">
          {{ data.rate }}
        </div>
        <div class="rate-name" :title="data.rateName">
          {{ data.rateName }}
        </div>
      </el-col>
    </el-row>
  </div>
  

</template>

<script>
export default {
  props:['data'],
};
</script>

<style  scoped>
.rate-card {
  padding: 12px 20px;
  margin: 5px;
  /* background: slategray; */
  border-radius: 3px;
  color: #fff;
}
.rate {
  font-size:36px;
  font-weight: 600;
}
.title {
  overflow: hidden;
  white-space: nowrap;	/*规定文本不进行换行*/
  text-overflow: ellipsis;
  line-height: 18px;
  height: 18px;
}
.arrow {
  font-size: 48px;
  font-weight: 600;
}
.down{
  transform:scaleY(-1)
}
.rate-name {
  overflow: hidden;
  white-space: nowrap;	/*规定文本不进行换行*/
  text-overflow: ellipsis;
  font-size: 14px;
}
.rate-number {
  font-weight: 600;
  margin: 5px 0;
  overflow: hidden;
  white-space: nowrap;	/*规定文本不进行换行*/
  text-overflow: ellipsis;
}
</style>
